import { GlobalStore } from '@web/csl-lib-store';
import { inject } from '@angular/core';
import { MedicalRecordRelease } from '@web/csl-lib-models';
import { MedicalRecordReleaseConstants } from '@web/csl-lib-constants';
import { MessageService } from 'primeng/api';
import { MrrUpdateDialogState } from './mrr-update-dialog.state';
import { MrrUpdateService } from '../services/mrr-update.service';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { pipe, switchMap, tap } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';

const initialState: MrrUpdateDialogState = {
  selectedItem: null,
  nextStateOptions: [],
  isLoading: false,
  error: null
}

export const MrrUpdateDialogStore = signalStore(
  withState(initialState),
  withMethods(
    (
      store,
      globalStore = inject(GlobalStore),
      messageService = inject(MessageService),
      mrrService = inject(MrrUpdateService)
    ) => ({
      loadMedicalRecordRelease: rxMethod<{ clinicId: number, healthRecordId:string, mrrId:number }>(
        pipe(
          switchMap((args) => {
            globalStore.setLoading();
            patchState(store, { isLoading: true, error: null });
            return mrrService.getMedicalRecordRelease(args.clinicId, args.healthRecordId, args.mrrId)
              .pipe(
                tap({
                  next: (mrr: MedicalRecordRelease) => {
                    patchState(store, { selectedItem: mrr });
                    const filteredOptions = MedicalRecordReleaseConstants.status.filter((s) => mrr.nextStates.includes(s.value));
                    patchState(store, { nextStateOptions: filteredOptions });
                  },
                  error: (e) => {
                    globalStore.unsetLoading();
                    console.error(e);
                  },
                  finalize: () => {
                    globalStore.unsetLoading();
                    patchState(store, { isLoading: false });
                  },
                }),

              );
          })
        )
      ),

      updateStatus: rxMethod<{ clinicId: number, mrr: MedicalRecordRelease, newState: number, comment: string }>(
        pipe(
          switchMap((args) => {
            globalStore.setLoading();
            patchState(store, { isLoading: true, error: null });
            return mrrService.updateStatus(args.clinicId, args.mrr.healthRecordId, args.mrr.id, args.newState, args.comment)
              .pipe(
                tap({
                  next: (mrr) => {
                    if(mrr !== null) {
                      patchState(store, { selectedItem: mrr });
                      const filteredOptions = MedicalRecordReleaseConstants.status.filter((s) => mrr.nextStates.includes(s.value));
                      patchState(store, { nextStateOptions: filteredOptions });
                      messageService.add({ severity: 'success', summary: 'Success!', detail: `Medical Record Release status updated.`, life: 3000 });
                      globalStore.unsetLoading();
                    } else {
                      messageService.add({ severity: 'error', summary: 'Error!', detail: `Error updating Medical Record Release status.`, life: 4000 });
                    }
                  },
                  error: (e) => {
                    console.error(e);
                    messageService.add({ severity: 'error', summary: 'Error!', detail: `Error updating Medical Record Release status.`, life: 4000 });
                  },
                  finalize: () => {
                    globalStore.unsetLoading();
                    patchState(store, { isLoading: false });
                  },
                }),
              );
          })
        )
      ),
      clear() {
        patchState(store, initialState);
      }

    })
  ),

);

